import { DistrictsData } from '@/entities';
import { DistrictsDto } from '@/infrastructure/network/dto';

export const districtsDtoToDistrictsData = (dto: DistrictsDto): DistrictsData => {
	return {
		teamLeagueDistricts: dto.team_league_districts.map((teamLeagueDistrictDto) => ({
			uuid: teamLeagueDistrictDto.uuid,
			title: teamLeagueDistrictDto.title,
			abbreviation: teamLeagueDistrictDto.abbreviation,
			logo: teamLeagueDistrictDto.logo
				? {
						uuid: teamLeagueDistrictDto.logo.uuid,
						url: teamLeagueDistrictDto.logo.url
					}
				: undefined,
			divisionsCount: teamLeagueDistrictDto.divisions_count,
			divisions: teamLeagueDistrictDto.divisions.map((divisionDto) => ({
				uuid: divisionDto.uuid,
				title: divisionDto.title,
				teamsCount: divisionDto.teams_count,
				playersCount: divisionDto.players_count
			}))
		}))
	};
};
